(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-group"] && !Shopify.designMode) return;
  try {
    (function() {
    // Initialize carousel scroll behavior
    function initCarousel(carouselEl) {
      const track = carouselEl.querySelector('[data-carousel-track]');
      const thumb = carouselEl.querySelector('[data-scroll-thumb]');
      
      if (!track) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      function updateScrollThumb() {
        if (!thumb) return;
        const scrollPercentage = track.scrollLeft / (track.scrollWidth - track.clientWidth);
        const trackWidth = thumb.parentElement.clientWidth;
        const thumbWidth = thumb.clientWidth;
        const maxThumbPosition = trackWidth - thumbWidth;
        
        thumb.style.transform = `translateX(${scrollPercentage * maxThumbPosition}px)`;
      }

      // Mouse drag to scroll
      track.addEventListener('mousedown', (e) => {
        isDown = true;
        track.classList.add('is-grabbing');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      track.addEventListener('mouseleave', () => {
        isDown = false;
        track.classList.remove('is-grabbing');
      });

      track.addEventListener('mouseup', () => {
        isDown = false;
        track.classList.remove('is-grabbing');
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        track.scrollLeft = scrollLeft - walk;
      });

      // Update thumb on scroll
      track.addEventListener('scroll', updateScrollThumb);
      
      // Update thumb on resize
      window.addEventListener('resize', updateScrollThumb);
      
      // Initial update
      updateScrollThumb();
    }

    // Initialize all carousels on the page
    document.querySelectorAll('.carousel-group').forEach(initCarousel);

    // Re-initialize on Shopify theme editor events
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        event.target.querySelectorAll('.carousel-group').forEach(initCarousel);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Mobile accordion for grandchild items
  (function() {
    function initMobileAccordion() {
      if (window.innerWidth >= 1160) return;

      document.querySelectorAll('.menu-drawer .menu-drawer__list-item--flat > .menu-drawer__menu-item--parent').forEach(function(link) {
        // Check if this item has grandchildren
        var parent = link.parentElement;
        var grandchildList = parent.querySelector('.menu-drawer__menu--grandchildlist');
        if (!grandchildList) return;

        link.addEventListener('click', function(e) {
          if (window.innerWidth >= 1160) return;
          e.preventDefault();
          parent.classList.toggle('is-open');
        });
      });
    }

    // Re-open all menu-drawer__menu-container details when drawer opens on mobile
    function keepMenusOpen() {
      if (window.innerWidth >= 1160) return;

      var mainDetails = document.getElementById('Details-menu-drawer-container');
      if (!mainDetails) return;

      // Observer to detect when drawer opens
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' && mainDetails.hasAttribute('open')) {
            // Drawer just opened, re-add open attribute to all menu containers
            document.querySelectorAll('.menu-drawer__menu-container').forEach(function(details) {
              details.setAttribute('open', '');
            });
          }
        });
      });

      observer.observe(mainDetails, { attributes: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initMobileAccordion();
        keepMenusOpen();
      });
    } else {
      initMobileAccordion();
      keepMenusOpen();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
  const containers = document.querySelectorAll('[data-carousel-container]');
  if (!containers.length) return;

  const MAX_VISIBLE_DOTS = 4; // Maximum dots to show at once on mobile

  containers.forEach(container => {
    const slideshow = container.querySelector('.slideshow-component') || container.querySelector('slideshow-component');
    const dotsWrapper = container.querySelector('[data-carousel-dots]');
    if (!slideshow || !dotsWrapper) return;

    const totalProducts = parseInt(container.dataset.carouselSlideCount, 10) || 1;

    function isMobile() {
      return window.innerWidth < 750;
    }

    function getProductsPerView() {
      const width = window.innerWidth;
      if (width < 750) {
        return 1;
      } else if (width < 990) {
        return 2;
      } else {
        return 4;
      }
    }

    function createDots() {
      dotsWrapper.innerHTML = '';
      dotsWrapper.classList.remove('has-many-dots');

      const productsPerView = getProductsPerView();
      const totalPages = Math.ceil(totalProducts / productsPerView);

      // Add class if we have many dots on mobile
      if (isMobile() && totalPages > MAX_VISIBLE_DOTS) {
        dotsWrapper.classList.add('has-many-dots');
      }

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('div');
        dot.classList.add('carousel-dot');
        dot.dataset.index = i;
        dot.addEventListener('click', () => {
          const targetSlide = i * productsPerView;
          if (typeof slideshow.select === 'function') {
            slideshow.select(targetSlide);
          } else if ('currentSlide' in slideshow) {
            slideshow.currentSlide = targetSlide;
            slideshow.dispatchEvent(new CustomEvent('slideshow:select', { detail: { index: targetSlide } }));
          }
        });
        dotsWrapper.appendChild(dot);
      }

      return { dots: dotsWrapper.querySelectorAll('.carousel-dot'), productsPerView, totalPages };
    }

    let { dots, productsPerView, totalPages } = createDots();

    function updateSlidingWindow(activeDotIndex) {
      if (!isMobile() || totalPages <= MAX_VISIBLE_DOTS) {
        // Show all dots normally
        dots.forEach(dot => {
          dot.classList.add('visible');
          dot.classList.remove('small');
        });
        return;
      }

      // Calculate window range (show 4 dots centered around active)
      let windowStart = activeDotIndex - 1;
      let windowEnd = activeDotIndex + 2;

      // Adjust window at edges
      if (windowStart < 0) {
        windowStart = 0;
        windowEnd = MAX_VISIBLE_DOTS;
      }
      if (windowEnd > totalPages) {
        windowEnd = totalPages;
        windowStart = Math.max(0, totalPages - MAX_VISIBLE_DOTS);
      }

      dots.forEach((dot, index) => {
        dot.classList.remove('visible', 'small');

        if (index >= windowStart && index < windowEnd) {
          dot.classList.add('visible');
          // Make edge dots smaller
          if (index === windowStart && windowStart > 0) {
            dot.classList.add('small');
          }
          if (index === windowEnd - 1 && windowEnd < totalPages) {
            dot.classList.add('small');
          }
        }
      });

      // Translate dots to center the visible window
      const dotWidth = 10;
      const dotGap = 8;
      const offset = windowStart * (dotWidth + dotGap);
      dotsWrapper.style.transform = `translateX(-${offset}px)`;
    }

    function updateDots(event) {
      let currentIndex = 0;

      if (event?.detail?.index !== undefined) {
        currentIndex = event.detail.index;
      } else if (slideshow.currentSlide !== undefined) {
        currentIndex = slideshow.currentSlide;
      } else if (slideshow.current !== undefined) {
        currentIndex = slideshow.current;
      }

      const dotIndex = Math.floor(currentIndex / productsPerView);

      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[dotIndex]) {
        dots[dotIndex].classList.add('active');
      }

      updateSlidingWindow(dotIndex);
    }

    slideshow.addEventListener('slideshow:select', updateDots);
    slideshow.addEventListener('slide-changed', updateDots);

    const observer = new MutationObserver(() => {
      updateDots({});
    });
    observer.observe(slideshow, {
      attributes: true,
      attributeFilter: ['data-current-slide', 'current-slide']
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newProductsPerView = getProductsPerView();
        if (newProductsPerView !== productsPerView) {
          const result = createDots();
          dots = result.dots;
          productsPerView = result.productsPerView;
          totalPages = result.totalPages;
          updateDots({});
        }
      }, 250);
    });

    updateDots({});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
